import React from 'react';
import useBreakpoint from 'use-breakpoint';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import { isMobile, MQ } from './Media';

import './BlockMap.scss';

const coords = [
{ address: '194355, г. Санкт-Петербург, пр-т Просвещения, д. 19, Лит. А', c1: 60.052703, c2: 30.331202 },
{ address: '121059, г. Москва, пл. Киевского вокзала, д. 2', c1: 55.744637, c2: 37.566072 },
{ address: '125171, г. Москва, ш. Ленинградское, д. 16 А, стр. 4', c1: 55.823216, c2: 37.497468 },
{ address: '191011, г. Санкт-Петербург, пр-т  Невский, д. 46, Лит. А', c1: 59.934804, c2: 30.333628 },
{ address: '193172, г. Санкт-Петербург, пр-т Лиговский, д. 10/118, Лит. А (буквоед)', c1: 59.932689, c2: 30.362634 },
{ address: '117519, г. Москва, ш.  Варшавское, вл. 140', c1: 55.612075, c2: 37.608050 },
{ address: '630091, г. Новосибирск, ул. Гоголя, д. 13', c1: 55.043721, c2: 82.922343 },
{ address: '192281, г. Санкт-Петербург, пл. Балканская, д. 5, Лит. О', c1: 59.831200, c2: 30.378049 },
{ address: '195220, г. Санкт-Петербург, пр-т Гражданский, д. 41, Лит. А', c1: 60.011540, c2: 30.397812 },
{ address: 'г. Москва, Ленинградский просп., 62А, Галерея Аэропорт, (этаж 2)', c1: 55.801835, c2: 37.532107 },
{ address: '121170, г. Москва, пр-т  Кутузовский, д. 57', c1: 55.727932, c2: 37.476169 },
{ address: '117587, г. Москва, ул. Перерва, д. 43, к. 1', c1: 55.659653, c2: 37.749670 },
{ address: '394006, г. Воронеж, ул. 20 лет Октября, д. 90', c1: 51.655981, c2: 39.188879 },
{ address: '199004, г. Санкт-Петербург, пр-т В. О. , Средний, д. 36/40', c1: 59.942025, c2: 30.276001 },
{ address: '195112, г. Санкт-Петербург, пр-т Заневский, д. 67, кор. 2, Лит. А', c1: 59.933027, c2: 30.437644 },
{ address: '195112, г. Санкт-Петербург, КС 83  Лиговский 30А  (Буквоед)', c1: 59.933027, c2: 30.437644 },
{ address: '109462, г. Москва, пр-т Волгоградский, д. 78', c1: 55.705164, c2: 37.763073 },
{ address: '191002, г. Санкт-Петербург, ТРК Меркурий, Савушкина 141 (Буквоед)', c1: 59.990899, c2: 30.205789 },
{ address: '620014, г. Екатеринбург, ул. Вайнера, д. 12', c1: 56.835771, c2: 60.594690 },
{ address: '660049, г. Красноярск, ул. Сурикова, д. 12', c1: 56.010191, c2: 92.877177 },
{ address: '630078, г. Новосибирск, пл. Карла Маркса, д. 3', c1: 54.984119, c2: 82.891603 },
];


const BlockMap: React.FC = () => {
    const { minWidth } = useBreakpoint(MQ, 'sm');

    return (
        <div className="block-map">
            <YMaps>
                <Map 
                    defaultState={{ center: [55.75, 37.57], zoom: 10 }} 
                    width="100%" 
                    height={isMobile(minWidth) ? "100vh" : "60vh"} 
                >
                    { coords.map((c, ix) => <Placemark
                        key={ix}
                        modules={["geoObject.addon.balloon"]}
                        defaultGeometry={[c.c1, c.c2]}
                        properties={{
                            balloonContentBody: c.address,
                        }}
                    />)}
                </Map>
            </YMaps>
        </div>
    );
};

export default BlockMap;